import { ReduxStore } from 'store/types';

function getAllErrorMsg(state: ReduxStore): string {
  return state.intervention.getAll.config.errorMsg;
}

export default getAllErrorMsg;
